import { render, staticRenderFns } from "./PbiReportViewer.vue?vue&type=template&id=225335f4&scoped=true&"
import script from "./PbiReportViewer.vue?vue&type=script&lang=js&"
export * from "./PbiReportViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225335f4",
  null
  
)

export default component.exports